import { fetchJson } from './fetchJson'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function post(url: string, data?: any): Promise<any> {
  return fetchJson({ method: 'POST', url, data })
}
